import { ActivityLogFilterType } from '../types/filterOptionsType';

export const initialState: ActivityLogFilterType = {
  keywordSearch: '',
  sortType: 'CreatedOn',
  sortOrder: 'desc',
  accountCidPid: '',
  cid: '',
  pid: '',
  personId: '',
  activity: '',
  createdOn: '', // activityDate
  createdBy: '',
  reportFileName: '',
  userId: '',
  userName: '',
  type: [],
  categoryActivity: [],
  personAlertId: '',
  submissionNumber: '',
  id: '',
  docId: '',
  source: undefined,
};

export const filterSortOptions: Array<string> = [
  'CID',
  'PID',
  'Activity',
  'CreatedOn',
  'CreatedBy',
  'PersonID',
];

// for the sort options in activity log - person repository tab and person alert tab
export const filterSortOptionsActivityLog: Array<string> = [
  'CID',
  'PID',
  'Activity',
  'CreatedOn',
  'CreatedBy',
  'UserName',
  'PersonId',
  'PersonAlertId',
  'FormId',
  'ReportFileName',
  'AccountCIDPID',
  'Source',
];

export const filterSortOptionsActivityAllLog: Array<string> = [
  'Id',
  'AccountId',
  'CreatedOn',
  'UserName',
  'Category',
  'Activity',
  'CID',
  'PID',
  'CreatedBy',
  'AccountCIDPID',
  'DocId',
];

export const activityTypes = [
  { value: 1, label: 'Call documents' },
  { value: 2, label: 'Person alerts' },
  { value: 3, label: 'Person repository' },
  { value: 4, label: 'Hospital form' },
];

export const activities = [
  {
    value: 1,
    label: 'View',
  },
  {
    value: 2,
    label: 'Edit',
  },
  {
    value: 3,
    label: 'Print',
  },
  {
    value: 4,
    label: 'Finalized',
  },
  {
    value: 5,
    label: 'Download',
  },
  {
    value: 6,
    label: 'Schedule call',
  },
];

export const activityTypeToActivitiesMap: Record<number, number[]> = {
  1: [1, 4, 5], // Call documents → View, Finalized, Download
  2: [1, 2, 3], // Person alerts → View, Edit, Download, Print
  3: [1, 2], // Person repository → View, Edit
  4: [1, 6], // Activity Tracker (Hospital form) → View, Schedule call
};

export const sourceList = [
  {
    label: 'Select All',
    value: 0,
  },
  {
    label:
      process.env.REACT_APP_THEME === 'lfl' ? 'Lines for Life' : 'Protocall',
    value: 1,
  },
  {
    label: 'Customer',
    value: 2,
  },
];
